export default {
    path: '/Explorer',
    meta: {
        title: '支付宝支付',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/Explorer`),
}


// WEBPACK FOOTER //
// ./src/views/Explorer/router.js